
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'projects/speaker-platform/src/app/services/toast.service';

@Component({
  selector: 'app-toasts',
  imports: [NgbToastModule],
  templateUrl: './toasts.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./toasts.component.scss']
})
export class ToastsComponent {
  constructor(public toastService: ToastService) {}
}
